import React, { useState, useRef } from "react";

import { checkValidity } from "../../utility/utility";
import styles from "./UserInput.module.css";

export const USERNAME_TYPE = {
  placeholder: "Username",
  validation: {
    required: true,
  },
  type: "username",
};
export const PSW_TYPE = {
  placeholder: "Password",
  validation: {
    required: true,
  },
  type: "password",
};
export const NUM_TYPE = {
  placeholder: "",
  validation: {
    required: true,
  },
  type: "number",
};

export const MAX_LENGTH_ENCRPYTED_INPUT = 100; //This is the limit of the cloud with encryption
const MAX_LENGTH_INPUT = 200; //This is the limit of the cloud
/**
 * User input
 * @param {Object} props {value: string, placeholder: string, validation: object, type: string, onEnter: on enter (function)}
 */
const useUserInput = (props) => {
  //Update lesion note state
  const [state, setState] = useState({
    value: props.value ? props.value : "",
    valid: props.value ? true : false,
    touched: props.value ? true : false,
  });
  //Ref
  const inputRef = useRef();
  //Configuration
  const config = {
    type: props.type ? props.type : "text",
    placeholder: props.placeholder ? props.placeholder : "",
    validation: props.validation ? props.validation : { required: true },
    maxLength: props.maxLength ? props.maxLength : MAX_LENGTH_INPUT,
  };
  //Style
  const inputClasses = [styles.InputElement];
  if (!state.valid && state.touched) {
    inputClasses.push(styles.Invalid);
  }
  //Input handler
  const inputChangedHandler = 
    (event) => {
      const newValue = {
        value: event.target.value,
        valid: checkValidity(event.target.value, config.validation),
        touched: true,
      };
      setState(newValue);
    };
  return [
    <div className={styles.Input}>
      <input
        ref={inputRef}
        className={inputClasses.join(" ")}
        value={state.value}
        onChange={(event) => inputChangedHandler(event)}
        type={config.type}
        placeholder={config.placeholder}
        onKeyPress={(event) =>
          event.key === "Enter" && props.onEnter ? props.onEnter(state) : null
        }
        maxLength={config.maxLength}
      />
    </div>,
    state,
    setState,
    inputRef,
  ];
};

export default useUserInput;
